<script setup lang="ts">
const props = defineProps<{
  orakle_update_error?: string
}>()
</script>
<template>
  <v-card
    color="pwt_marigold_40"
    rounded="lg"
    style="border: 1px solid rgb(var(--v-theme-pwt_medium_orange))"
    class="mb-10"
    flat
  >
    <v-card-title> No recent live data </v-card-title>
    <v-card-text v-if="props.orakle_update_error === 'Vehicle not found in Orakle.'">
      This vehicle does not appear to have any recent or ever had any connected live data.
    </v-card-text>
    <v-card-text v-else>
      Their appears to be an issue with connecting live data with this vehicle.
    </v-card-text>
  </v-card>
</template>
